import React, {useEffect, useState} from 'react';


const AIInsightComponent = () => {
    const [tickers, setTickers] = useState([]);
    const[results, setResults] = useState([]);

    useEffect(() => {
        const fetchAIInsights = async () => {
            try {

                let url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_POSITION_SERVICE_DEV : "";

                const positionsRes = await fetch(url + '/positions');
                const positionResult = await positionsRes.json();

                const tickers = Object.keys(positionResult);
                setTickers(tickers);
                let aiAgentUrl = process.env.NODE_ENV === 'development'
                    ? "http://192.168.1.152:8090" : "https://finbotics.xyz";

                await Promise.all(
                tickers.map(async (ticker) => {
                    const response = await fetch(aiAgentUrl + "/analyze", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ticker }),
                    });
                    const data = await response.json();
                    setResults((prev) => ({ ...prev, [ticker]: data.result }));
                })
                );
        
              } catch (error) {
                console.error("Error fetch AI insights. ", error);
              }
        };

        fetchAIInsights();
    }, []);

    return (
         <React.Fragment>
        <div style={{marginLeft: '2%', width: '90%'}}>
        <h1 className="text-2xl font-bold mb-6 text-gray-800">AI Analysis</h1>

        <div className="space-y-4">
            {tickers.map((ticker) => (
            <div
                key={ticker}
                className="p-5 rounded-2xl shadow-md bg-white border border-gray-200 hover:shadow-lg transition-shadow"
            >
                {/* Header */}
                <div className="flex items-center justify-between mb-3">
                <h2 className="text-lg font-semibold text-indigo-600">{ticker}</h2>
                </div>

                {/* Content */}
                <pre
                className="text-base font-normal break-words overflow-x-hidden text-gray-800 whitespace-pre-line leading-relaxed font-serif"
                style={{"fontSize": "15px", lineWeight: "1.5"}}
                >
                {results[ticker] ? results[ticker] : "Loading..."}
                </pre>
            </div>
            ))}
        </div>
        </div>
         </React.Fragment>
    )

};

export default AIInsightComponent;
